<p>hl-display-stripe-payment-step works!</p>
